import { gsap } from "./gsap";

export interface RevealOptions {
  /** 子元素选择器（相对 scope），默认 [data-reveal] */
  selector?: string;
  /** 元素间错位时间 */
  stagger?: number;
  /** 起始 Y 位移 */
  y?: number;
  duration?: number;
  /** ScrollTrigger start，默认进入视口 85% */
  start?: string;
}

/**
 * 统一的滚动揭示：对 scope 内的 [data-reveal] 元素做淡入上移。
 * 在 useGSAP 回调中调用，自动随 context 清理。
 */
export function revealOnScroll(scope: Element, options: RevealOptions = {}) {
  const { selector = "[data-reveal]", stagger = 0.08, y = 28, duration = 0.7, start = "top 85%" } = options;
  const targets = gsap.utils.toArray<HTMLElement>(scope.querySelectorAll(selector));
  if (!targets.length) return [];

  return targets.map((el, index) =>
    gsap.from(el, {
      opacity: 0,
      y,
      duration,
      ease: "power3.out",
      delay: index * stagger,
      scrollTrigger: {
        trigger: el,
        start,
        once: true,
      },
    }),
  );
}
